import type { InterludeTypes } from "@/interlude";

export const isEditableMetaChannelType = <
  T extends Pick<InterludeTypes["Channel"], "type">,
>(
  channel: T,
): channel is Extract<T, { type: "fb" | "ig" }> => {
  return channel.type === "fb" || channel.type === "ig";
};
